import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    dataPoint: {
      display: 'inline-flex',
      gap: '8px',
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0.25),
      margin: theme.spacing(-0.25, 1, -0.25, -0.25),
    },
    dataPointLabel: {
      fontWeight: 'bold',
    },
    secondaryPoint: {
      '&:hover': {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[1],
      },
    },
    secondaryLabel: {
      color: theme.palette.text.secondary,
    },
    diffCreate: {
      color: theme.palette.success.main,
    },
    diffChange: {
      color: theme.palette.info.main,
    },
    diffRemove: {
      color: theme.palette.error.main,
    },
    changeArrow: {
      verticalAlign: 'text-bottom',
      fontSize: '1rem',
    },
  };
};
